import { render } from "./customSide.vue?vue&type=template&id=af49ed94&scoped=true"
import script from "./customSide.vue?vue&type=script&lang=js"
export * from "./customSide.vue?vue&type=script&lang=js"

import "./customSide.vue?vue&type=style&index=0&id=af49ed94&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af49ed94"]])

export default __exports__